/** @jsx h */
import { labels } from '../config';
import { Fragment } from 'preact';
import FilterSubCheckbox from './FilterSubCheckbox';

const FilterCheckbox = ({
  option,
  filterName,
  handleChange,
  pluginNamespace,
}) => {
  return (
    <Fragment>
      <input
        id={`${filterName}-${option.value}`}
        type="checkbox"
        class="search-checkbox__input sr-only"
        name={`${pluginNamespace}[filter][]`}
        value={`${filterName}:${option.value}`}
        data-label={`${filterName}-${option.label}`}
        onChange={handleChange}
        checked={option.selected}
      />
      <label
        htmlFor={`${filterName}-${option.value}`}
        class="search-checkbox__label"
      >
        <span class="search-checkbox__label-mark" aria-hidden="true" />
        <span class="search-checkbox__label-text">{option.label}</span>
        {option.documentCount && (
          <span class="search-checkbox__hits">
            <span class="sr-only">{labels.faceting.filterHits}:</span> (
            {option.documentCount})
          </span>
        )}
      </label>
      {option.options && (
        <ul class="search-checkbox__subcheckbox-list">
          {option.options.map((option, index) => (
            <li class="search-checkbox search-checkbox--sub" key={option.name}>
              <FilterSubCheckbox
                option={option}
                filterName={filterName}
                handleChange={handleChange}
                pluginNamespace={pluginNamespace}
              />
            </li>
          ))}
        </ul>
      )}
    </Fragment>
  );
};

export default FilterCheckbox;
